import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

import type { ClinicalNote } from './useExistingNotes';

const fetchNoteById = async ({
  currentPracticeId,
  currentOrganizationId,
  clinicalNoteId,
}: {
  currentPracticeId: string;
  currentOrganizationId: string;
  clinicalNoteId: string;
}) => {
  return makeAPIRequestReactQuery<ClinicalNote>(
    `/videa-notes/${clinicalNoteId}`,
    {},
    'get',
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        practice: currentPracticeId,
        org: currentOrganizationId,
      },
    },
  );
};

export const useNoteById = (
  clinicalNoteId: string | undefined,
  enabled: boolean,
) => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'videa-note-by-id',
      currentOrganizationId,
      currentPracticeId,
      clinicalNoteId,
    ],
    queryFn: () => {
      return fetchNoteById({
        currentPracticeId,
        currentOrganizationId,
        clinicalNoteId: clinicalNoteId!,
      });
    },
    enabled: !!clinicalNoteId && enabled,
  });
};

